import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { CustomButtonDesktop as CoreCustomButtonDesktop } from '@alfalab/core-components-custom-button/desktop';

import type { IDeps, TCustomButton } from './models';
import { CustomButton as Component } from './custom-button';
import styles from './styles/styles.css';

export const CustomButtonDesktop = createWidget<IDeps, TCustomButton>(
    { CustomButton: CoreCustomButtonDesktop, styles },
    { priorityStyler: true }
)(Component);
